/**
 * Initial release: Flagged Cancellations feature code remains in the app;
 * UI entry points are hidden until a follow-up release enables them.
 */
export const FLAGGED_CANCELLATIONS_UI_VISIBLE = false;

/**
 * Initial redesign release: tutorial YouTube embeds are hidden until videos are
 * re-recorded for the new portal UX. Set to true to restore Featured videos tab
 * and the topbar video guide slider.
 */
export const PORTAL_GUIDE_VIDEOS_VISIBLE = false;

/**
 * Initial redesign release: documentation screenshots are hidden until they are
 * recaptured from the final portal UI. Set to true to restore guide images.
 */
export const PORTAL_GUIDE_SCREENSHOTS_VISIBLE = false;
